/**
 * homePath.ts — destinazione iniziale per tipo di utente.
 *
 * Estratto da router.tsx (Ott 2026) per evitare un import circolare:
 * EventsEntry (pagina /events pubblica) deve rimandare dealer/admin alla loro
 * area senza importare il router che la renderizza.
 */

export function homePathForUser(userType?: string, isLocale?: boolean): string {
  // ADMIN prima di tutto (Ott 2026): un admin può essere anche nella squadra di
  // un locale per prova, ma non deve essere spedito nel pannello del locale al
  // login (era successo: profilo admin "dirottato" sull'area Tappa/Locale).
  if (userType === "admin") return "/admin";
  // LOCALE/TAPPA (Ott 2026): il locale accede come "dealer" ma non ha
  // abbonamento né chapter → va dritto nel suo pannello, senza gli avvisi
  // da concessionario.
  if (isLocale) return "/locale";
  if (userType === "dealer") return "/dealer/dashboard";
  return "/dashboard";
}
